import { Injectable } from '@angular/core';
import * as Rx from 'rxjs';
import { AppSettingService } from '../app.service';
import { CacheService } from '../utility/cache.service';

@Injectable({
	providedIn: 'root'
})
export class BLSAPIService {
	constructor(
		private cacheSrv: CacheService
	) { }

	private url = AppSettingService.appConfig.JourneyAPIUrl + "BLS";

	getEstablishment(zipCode: string, state: string, periods: number, onlyIT: boolean): Rx.Observable<any> {
		let l = this.url + "/Establishment?zipCode=" + zipCode + "&state=" + state + "&periods=" + periods.toString() + "&onlyIT=" + onlyIT.toString();
		return this.cacheSrv.get(true, l);
	}

	getWeeklyWage(zipCode: string, state: string, periods: number, onlyIT: boolean): Rx.Observable<any> {
		let l = this.url + "/WeeklyWage?zipCode=" + zipCode + "&state=" + state + "&periods=" + periods.toString() + "&onlyIT=" + onlyIT.toString();
		return this.cacheSrv.get(true, l);
	}

	getEmployment(zipCode: string, state: string, periods: number, onlyIT: boolean): Rx.Observable<any> {
		let l = this.url + "/Employment?zipCode=" + zipCode + "&state=" + state + "&periods=" + periods.toString() + "&onlyIT=" + onlyIT.toString();
		return this.cacheSrv.get(true, l);
	}

	getUnemploymentRate(zipCode: string, state: string, periods: number): Rx.Observable<any> {
		let l = this.url + "/UnemploymentRate?zipCode=" + zipCode + "&state=" + state + "&periods=" + periods;
		return this.cacheSrv.get(true, l);
	}

	GetOccupationWage(onetCode: string, zipCode: string, state: string): Rx.Observable<any> {
		let l = this.url + "/Occupation/" + onetCode + "/Wage?zipCode=" + zipCode + "&state=" + state;
		return this.cacheSrv.get(true, l);
	}
}
